import { read, utils } from "xlsx";

export const SHEET_REPRESENTANTES = "Representantes";
export const SHEET_RELACAO_CIDADES = "Relação de Cidades";

const HEADERS_REPRESENTANTES = [
  "CNPJ",
  "Representação",
  "Nome Representante",
  "Telefone 1",
  "Telefone 2",
  "Telefone 3",
  "E-mail",
  "Karsten Decor",
  "Karsten",
  "Trussardi",
];

const HEADERS_RELACAO_CIDADES = [
  "Cód. IBGE",
  "Nm Cidade",
  "UF",
  "Cidade/UF",
  "Marca",
  "Representação",
  "Nome Representante",
  "Telefone 1",
  "Telefone 2",
  "Telefone 3",
  "E-mail",
  "Cód. Representante",
  "CC",
];

function normalizeHeader(value) {
  return String(value ?? "")
    .trim()
    .toUpperCase();
}

function validateHeaders(expected, actual, sheetName) {
  if (!actual?.length || actual.length < expected.length) {
    return `A planilha "${sheetName}" não está no layout esperado. Verifique as colunas do arquivo.`;
  }

  for (let i = 0; i < expected.length; i += 1) {
    if (normalizeHeader(actual[i]) !== normalizeHeader(expected[i])) {
      return `A planilha "${sheetName}" não está no layout esperado. Coluna ${i + 1} deve ser "${expected[i]}".`;
    }
  }

  return null;
}

function getSheetHeaders(workbook, sheetName) {
  const sheet = workbook.Sheets[sheetName];
  if (!sheet) return null;

  const rows = utils.sheet_to_json(sheet, { header: 1, defval: "" });
  return rows[0] ?? [];
}

export function validateRepresentanteCidadeXlsx(workbook) {
  if (!workbook?.SheetNames?.length) {
    return "Arquivo XLSX inválido ou sem planilhas.";
  }

  if (!workbook.SheetNames.includes(SHEET_REPRESENTANTES)) {
    return `Planilha obrigatória "${SHEET_REPRESENTANTES}" não encontrada no arquivo.`;
  }

  if (!workbook.SheetNames.includes(SHEET_RELACAO_CIDADES)) {
    return `Planilha obrigatória "${SHEET_RELACAO_CIDADES}" não encontrada no arquivo.`;
  }

  const representantesError = validateHeaders(
    HEADERS_REPRESENTANTES,
    getSheetHeaders(workbook, SHEET_REPRESENTANTES),
    SHEET_REPRESENTANTES
  );
  if (representantesError) return representantesError;

  const cidadesError = validateHeaders(
    HEADERS_RELACAO_CIDADES,
    getSheetHeaders(workbook, SHEET_RELACAO_CIDADES),
    SHEET_RELACAO_CIDADES
  );
  if (cidadesError) return cidadesError;

  return null;
}

export async function readRepresentanteCidadeWorkbook(file) {
  const buffer = await file.arrayBuffer();
  return read(buffer, { type: "array" });
}

export function validateRepresentanteCidadeFile(file) {
  if (!file) return "Nenhum arquivo selecionado";

  const extension = file.name.split(".").pop()?.toLowerCase();
  if (extension !== "xlsx") {
    return "Formato do arquivo inválido! Apenas XLSX é aceito.";
  }

  if (
    file.type &&
    file.type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ) {
    return "Formato do arquivo inválido! Apenas XLSX é aceito.";
  }

  return null;
}
